/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
// libraries
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { isColorLight, useWindowSize } from '../../utils/FunctionsGlobals';
// utils
import { trackLead } from '../whatsAppButton/WhatsAppButton';
import styles from './DrawerComponent.module.css';

// interface
interface IDrawerComponent {
    site: any;
    activeDrawer: boolean;
    setActiveDrawer: any;
    favorito: Array<number>;
    vips?: any;
    menus: any;
}

const DrawerComponent: React.FC<IDrawerComponent> = ({
    site,
    activeDrawer,
    setActiveDrawer,
    favorito,
    vips,
    menus
}): any => {
    // constants
    const size = useWindowSize();
    const [vips2, setVips2] = useState<any>(vips || "");
    const renderText = () => {
        return `/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?favoritos=${favorito}`;
    };

    const cor_letras = isColorLight(site?.cor10) ? site?.cor11 : site?.cor13
    const cor_titulos = (isColorLight(site?.cor2) && isColorLight(site?.cor10)) || (!isColorLight(site?.cor2) && !isColorLight(site?.cor10)) ? cor_letras : site?.cor2

    // methods
    const closeDrawer = () => {
        setActiveDrawer(false);
    };

    // useEffect
    useEffect(() => {
        if (activeDrawer === false) {
            setTimeout(() => {
                setActiveDrawer(null);
            }, 450);
        }
    }, [activeDrawer]);

    useEffect(() => {
        if(!vips2){
            const vip: any = localStorage.getItem('vip');
            if(vip){
                setVips2(vip)
            }
        }
    }, [vips2]);

    if (activeDrawer) {
        return (
            <div className={styles.container_all_drawer}>
                {size?.width > 600 ? (
                    <div
                        onClick={closeDrawer}
                        className={styles.container_background}
                    />
                ) : null}
                <div className={styles.container_drawer} style={{backgroundColor: site?.cor10}}>
                    <div className={styles.closed_modal} onClick={closeDrawer}>
                        <MdClose size={32} color={cor_letras} />
                    </div>
                    <Link href='/' title="Clique aqui para ser direcionado para a home do site.">
                        <img
                            src={site?.id == 2315 ? "https://fotos.sobressai.com.br/Banner/2315/11488.jpg" : site?.id == 2231 ? "https://fotos.sobressai.com.br/importacoes/import_xml/xml/logo/2231.png" : site?.id == 2245 ? "https://fotos.sobressai.com.br/Banner/2245/11400.jpg" : site?.id == 2155 ? "https://fotos.sobressai.com.br/Banner/2155/11155.jpg" : site?.url_logo}
                            alt={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                            title={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                            className={styles.logo_welcome}
                            style={site?.id == 2304 ? {maxHeight: "110px"} : {}}
                        />
                    </Link>
                    <div className={styles.info_header} style={{ color: cor_titulos }}>IMÓVEIS</div>
                    { site?.transacoes?.map((v: any, index: number) =>
                        v && site?.id != 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/"+v.toLowerCase()+"/-/-/-/-"} key={index} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para buscar imóveis de venda ${v == "aluguel" ? "alugar" : v.toLowerCase()}`}
                                    title={`Imóveis para ${v == "aluguel" ? "alugar" : v.toLowerCase()}`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Imóveis para {v.toLowerCase() == "aluguel" ? "alugar" : v.toLowerCase()}</div>
                                </div>
                            </Link>
                        :null
                    )}


                    {site?.id == "1952" ?
                        <a
                            href={"https://mkt.executiveimobiliaria.com.br/mkt-executiveimobiliaria-com-br/consorcio"}
                            aria-label={`Botão para navegar a página de Consórcio Imobiliário`}
                            title={`Clique aqui para ver as opções de Consórcio Imobiliário`}
                            style={{width: "100%"}}
                        >
                            <div className={styles.info_body} style={{color: cor_letras}}>Consórcio imobiliário</div>
                        </a>
                    : null
                    }

                    { favorito?.length > 0 ?
                        <Link prefetch={false} style={{width: "100%"}} href={renderText()} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Botão para navegar a lista de imóveis marcados com favoritos`}
                                title={`Clique aqui para ver seus imóveis favoritos`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Favoritos</div>
                            </div>
                        </Link>
                    : null }

                    { vips2 ?
                        <Link prefetch={false} style={{width: "100%"}} href={vips2} target="_blank" rel="noopener noreferrer" passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Botão para navegar a lista de imóveis exclusivos`}
                                title={`Clique aqui para ver seus imóveis exclusivos`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Imóveis exclusivos</div>
                            </div>
                        </Link>
                    : null }
                    { site?.id == 2059 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/-?categoria=9999"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Botão para navegar a lista de imóveis Exclusivos`}
                                title={`Clique aqui para ver os imóveis Exclusivos`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Imóveis exclusivos</div>
                            </div>
                        </Link>
                    : null }
                     { site?.id == 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/casa-em-condominio+casa-a-venda-em-condominio+casa-em-condominio-%7C-lancamento"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Acessar lista de casas em condomínio`}
                                title={`Acessar lista de casas em condomínio`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Casas em condomínio</div>
                            </div>
                        </Link>
                    : null }
                    { site?.id == 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/casa-fora-de-condominio"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Acessar lista de casas fora de condomínio`}
                                title={`Acessar lista de casas fora de condomínio`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Casas avulsas imóvel novo</div>
                            </div>
                        </Link>
                    : null }
                    { site?.id == 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/apartamentos"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Acessar lista de apartamentos`}
                                title={`Acessar lista de apartamentos`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Apartamentos</div>
                            </div>
                        </Link>
                    : null }
                     { site?.id == 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/-?categoria=18"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Acessar lista de Imóveis usados`}
                                title={`Acessar lista de Imóveis usados`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Imóvel usado</div>
                            </div>
                        </Link>
                    : null }
                    { site?.id == 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/aparthause"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Acessar lista de Aparthause`}
                                title={`Acessar lista de Aparthause`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>ApartHause</div>
                            </div>
                        </Link>
                    : null }
                     { site?.id == 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/lotes"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Acessar lista de Lotes`}
                                title={`Acessar lista de Lotes`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Lotes</div>
                            </div>
                        </Link>
                    : null }
                    { site?.promocao && site?.id != 2097 ?
                        <Link prefetch={false} style={{width: "100%"}} href={"/imoveis/venda/-/-/-/-?promocao=1"} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Botão para navegar a lista de imóveis em promoção`}
                                title={`Clique aqui para ver os imóveis em promoção`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>{site?.id == "1630" ? "Off Market" : "Imóveis em Promoção"}</div>
                            </div>
                        </Link>
                    : null }

                    {site?.id == "1952" ?
                        <>
                            <div className={styles.info_header} style={{color: cor_letras}}>EMPREENDIMENTOS</div>
                            <a
                                href={"https://mkt.executiveimobiliaria.com.br/giardinomontemerano"}
                                style={{width: "100%"}}
                                aria-label={`Botão para navegar a página do empreendimento Giardino Montemerano`}
                                title={`Clique aqui para navegar a página do empreendimento Giardino Montemerano`}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Giardino Montemerano</div>
                            </a>
                        </>
                    : null
                    }


                    <div className={styles.info_header} style={{color: cor_titulos}}>SERVIÇOS</div>
                    { menus?.map((v: {titulo: string, link: string, Disponivel: boolean, Conteudo: string, Menu: boolean, Topo: boolean, Rodape: boolean, Destino: string}, cont: number) =>
                        v?.Disponivel && !v?.link && v?.titulo != "Equipe" ?
                            <Link prefetch={false} style={{width: "100%"}} href={"/menu/"+v?.titulo} key={cont} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                    title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                </div>
                            </Link>
                        :
                        v?.link && v?.Disponivel ?
                            <Link prefetch={false} style={{width: "100%"}} href={v?.link} key={v?.titulo} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                    title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                </div>
                            </Link>
                        :null
                    )}
                    { site?.id != "1925" && site?.id != "2016" && site?.id != "2243" ?
                        <>
                            <a
                                rel="noopener noreferrer"
                                href={site?.id == 2212 ? "https://lp.igorcardosoimoveis.com.br/anuncie" : site?.id == 2133 ? "https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Olá, gostaria de anunciar um imóvel.` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Olá, gostaria de anunciar um imóvel.`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == 2212 ? "https://lp.igorcardosoimoveis.com.br/anuncie" : site?.id == 2133 ? "https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Olá, gostaria de anunciar um imóvel.` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Olá, gostaria de anunciar um imóvel.`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para anunciar seu imóvel`}
                                title={`Clique aqui para anunciar seu imóvel`}
                                className={styles.info_body}
                                style={{color: cor_letras}}
                            >
                                Anuncie seu imóvel
                            </a>
                            <a
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para receber ajuda ao encontrar seu imóvel`}
                                title={`Clique aqui para receber ajuda ao encontrar seu imóvel`}
                                className={styles.info_body}
                                style={{color: cor_letras}}
                            >
                                {site?.id == 1630 ? "Construímos seu imóvel" : "Não encontrou seu imóvel?"}
                            </a>
                        </>
                    : null }
                    <Link prefetch={false} style={{width: "100%"}} href="/termos" passHref>
                        <div
                            style={{width: "100%"}}
                            aria-label={`Botão para ver os termos de uso`}
                            title={`Clique aqui para ver os termos de uso`}
                        >
                            <div className={styles.info_body} style={{color: cor_letras}}>Termos de uso</div>
                        </div>
                    </Link>
                    <Link prefetch={false} style={{width: "100%"}} href="/politica" passHref>
                        <div
                            style={{width: "100%"}}
                            aria-label={`Botão para ir a página Política de Privacidade`}
                            title={`Clique aqui para ir a página Política de Privacidade`}
                        >
                            <div className={styles.info_body} style={{color: cor_letras}}>
                                Política de privacidade
                            </div>
                        </div>
                    </Link>
                    <div className={styles.info_header} style={{color: cor_titulos}}>CONTATO</div>
                    { menus?.filter((v: any) => v?.titulo == "Equipe").length > 0 ?
                        <Link prefetch={false} href="/menu/Equipe" style={{width: "100%"}} passHref>
                            <div
                                style={{width: "100%"}}
                                aria-label={`Botão para ir a página Equipe`}
                                title={`Clique aqui para ir a página Equipe`}
                            >
                                <div className={styles.info_body} onClick={closeDrawer} style={{color: cor_letras}}>Equipe</div>
                            </div>
                        </Link> : null
                    }
                    {site?.id == "1952" ?
                    <>
                        <div className={styles.info_body} style={{color: cor_letras}}>Email: venda@executiveimobiliaria.com.br</div>
                    </>
                    : null
                    }
                    <a
                        rel="noopener noreferrer"
                        href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                    /\D/g,
                                    ''
                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                    /\D/g,
                                    ''
                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático

                            trackLead(site, null); // 🔥 Registra o evento Lead

                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                            window.open(
                                site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                    /\D/g,
                                    ''
                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                    /\D/g,
                                    ''
                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                "_blank"
                            );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                        }}
                        aria-label={`Botão para falar com a aquipe de atendimento`}
                        title={`Clique aqui para falar com a aquipe de atendimento`}
                        className={styles.info_body}
                        style={{color: cor_letras}}
                    >
                        Fale Conosco
                    </a>

                    {site?.Dados?.tel1 && site?.tel1_whats ? (
                        <a
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            aria-label={`Botão para enviar mensagem no WhatsApp 1 da imobiliária`}
                            title={`Clique aqui para enviar mensagem no WhatsApp 1 da imobiliária`}
                            className={styles.contatoNumero}
                            style={{color: cor_letras}}
                        >
                            {site?.Dados?.tel1}
                        </a>
                    ) : null}
                    {site?.Dados?.tel2 && site?.tel2_whats ? (
                        <a
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` :`https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` :`https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            aria-label={`Botão para enviar mensagem no WhatsApp 2 da imobiliária`}
                            title={`Clique aqui para enviar mensagem no WhatsApp 2 da imobiliária`}
                            className={styles.contatoNumero}
                            style={{color: cor_letras}}
                        >
                            {site?.Dados?.tel2}
                        </a>
                    ) : null}
                    {site?.Dados?.tel3 && site?.tel3_whats ? (
                        <a
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel3?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel3?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel3?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel3?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            aria-label={`Botão para enviar mensagem no WhatsApp 3 da imobiliária`}
                            title={`Clique aqui para enviar mensagem no WhatsApp 3 da imobiliária`}
                            className={styles.contatoNumero}
                            style={{color: cor_letras}}
                        >
                            {site?.Dados?.tel3}
                        </a>
                    ) : null}
                    {site?.Dados?.tel4 && site?.tel4_whats ? (
                        <a
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel4?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel4?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel4?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel4?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            aria-label={`Botão para enviar mensagem no WhatsApp 4 da imobiliária`}
                            title={`Clique aqui para enviar mensagem no WhatsApp 4 da imobiliária`}
                            className={styles.contatoNumero}
                            style={{color: cor_letras}}
                        >
                            {site?.Dados?.tel4}
                        </a>
                    ) : null}
                    <div className={styles.container_network}>
                        <div>
                            {site?.Dados?.youtube ? (
                                <a
                                    rel="noreferrer"
                                    href={site?.Dados?.youtube}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.Dados?.youtube,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    aria-label={`Botão para acessar o nosso canal no Youtube`}
                                    title={`Clique aqui para acessar o nosso canal no Youtube`}
                                    className={styles.network}
                                >
                                    <svg
                                        viewBox="0 0 24 24"
                                        height={24}
                                        width={24}
                                    >
                                        <path
                                            fill="#fff"
                                            d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
                                        ></path>
                                    </svg>
                                </a>
                            ) : null}
                            {site?.Dados?.instagram ? (
                                <a
                                    href={site?.Dados?.instagram}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.Dados?.instagram,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    rel="noreferrer"
                                    aria-label={`Botão para acessar o nosso perfil no Instagram`}
                                    title={`Clique aqui para acessar o nosso perfil no Instagram`}
                                    className={styles.network}
                                >
                                    <svg
                                        viewBox="0 0 24 24"
                                        height={24}
                                        width={24}
                                    >
                                        <path
                                            fill="#fff"
                                            d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
                                        ></path>
                                    </svg>
                                </a>
                            ) : null}
                            {site?.Dados?.facebook ? (
                                <a
                                    href={site?.Dados?.facebook}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.Dados?.facebook,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    rel="noreferrer"
                                    aria-label={`Botão para acessar o nosso perfil no Facebook`}
                                    title={`Clique aqui para acessar o nosso perfil no Facebook`}
                                    className={styles.network}
                                >
                                    <svg
                                        viewBox="0 0 24 24"
                                        height={24}
                                        width={24}
                                    >
                                        <path
                                            fill="#fff"
                                            d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"
                                        ></path>
                                    </svg>
                                </a>
                            ) : null}
                        </div>
                        {site?.id != 2243 ?
                            <a
                                className={styles.contact}
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                    site?.Dados?.tel1 ||
                                    site?.Dados?.tel2 ||
                                    site?.Dados?.tel3 ||
                                    site?.Dados?.tel4
                                )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${(
                                    site?.Dados?.tel1 ||
                                    site?.Dados?.tel2 ||
                                    site?.Dados?.tel3 ||
                                    site?.Dados?.tel4
                                )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel1 ||
                                            site?.Dados?.tel2 ||
                                            site?.Dados?.tel3 ||
                                            site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel1 ||
                                            site?.Dados?.tel2 ||
                                            site?.Dados?.tel3 ||
                                            site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para falar com a aquipe de atendimento`}
                                title={`Clique aqui para falar com a aquipe de atendimento`}
                            >
                                <i className="fa fa-whatsapp" />
                                Whatsapp
                            </a>
                        :null}
                    </div>
                </div>
            </div>
        );
    }
    if (activeDrawer === false) {
        return (
            <div className={styles.container_all_drawer_close}>
                <div
                    onClick={closeDrawer}
                    className={styles.container_background}
                />
                <div className={styles.container_drawer}>
                    <img
                        src={site?.id == 2155 ? "https://fotos.sobressai.com.br/Banner/2155/11155.jpg" : site?.url_logo}
                        alt={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                        title={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                        className={styles.logo_welcome}
                    />
                </div>
            </div>
        );
    }
};

export default DrawerComponent;
